import React, { Component } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { MemoryRouter, HashRouter, Route, Routes, Navigate } from "react-router-dom";
//import Timeline from "./components/timeline/";
import { CreditPowerDisplay, SavingsDisplay } from "./components/score-display/";
import ChoosingPlastic from "./pages/choosing-plastic/";
import SavingFirst from "./pages/saving-first";
import Budgeting from "./pages/budgeting";
import TransactionDetective from "./pages/transaction-detective";
import BirthdaySurprise from "./pages/birthday-suprise";
import TheFluStrikes from "./pages/the-flu-strikes";
import PlasticMail from "./pages/plastic-mail";
import MissingCard from "./pages/missing-card";
import GettingOnline from "./pages/getting-online";
import CreditCheck from "./pages/credit-check";
import Intro from "./pages/intro";
import gameData from "./store";
import { observer } from 'mobx-react';
import Analytics from "./components/analytics";

const dev = process.env.REACT_APP_ENV === "development";
const Router = dev ? HashRouter : MemoryRouter;

const decisions = [
  SavingFirst,
  ChoosingPlastic,
  props => <Budgeting iterationNumber={0} {...props} />,
  TransactionDetective,
  GettingOnline,
  BirthdaySurprise,
  TheFluStrikes,
  PlasticMail,
  MissingCard,
  CreditCheck
];

const getBasePath = location => {
  let parts = location.split("/");
  parts.pop();
  return parts.join("/");
};

class App extends Component {
  render() {
    const { creditPower, savings } = gameData;
    return (
      <Router>
        <Routes>
          <Route
            path="*"
            element={
              <div className="container">
                <Analytics
                  basePath={getBasePath(window.location.pathname)}
                  trackingId="G-TEBXLZGN04"
                  gameStartRoute="/"
                  gameEndRoute="/9"
                />
                <div className="hud">
                  <CreditPowerDisplay value={creditPower} />
                  
                  <SavingsDisplay value={savings} />
                </div>

                <div className="page-wrapper">
                  <TransitionGroup component={null}>
                    <CSSTransition
                      key={window.location.pathname}
                      timeout={1200}
                      classNames="fade-zoom-"
                    >
                      <Routes>
                        <Route
                          path="/"
                          element={<Intro gameData={gameData} nextRoute="/0" />}
                        />

                        {decisions.map((Component, i) => (
                          <Route
                            key={i}
                            path={`/${i}`}
                            element={
                              <Component
                                gameData={gameData}
                                nextRoute={i >= decisions.length - 1 ? "/" : `/${i + 1}`}
                              />
                            }
                          />
                        ))}

                        <Route path="*" element={<Navigate to="/" />} />
                      </Routes>
                    </CSSTransition>
                  </TransitionGroup>
                </div>
              </div>
            }
          />
        </Routes>
      </Router>
    );
  }
}

export default observer(App);
